import { SetupContext } from "@vue/composition-api";
import { findGetters as findScoreGetters } from "@dcc/store/score/getters";
import { findGetters } from "@dcc/store/drinking/getters";
import { Drinks } from "@dcc/types/drinks";
import { DrinkFrequency } from "@dcc/types/drinkFrequency";

export const useWeeklyUnits = (context: SetupContext) => {
  const { getWeeklyDrinkingDays, getDrinkFrequency } = findGetters(
    context.root.$store
  );
  const drinkFrequency = getDrinkFrequency().value;
  const numberDrinkingDays = getWeeklyDrinkingDays().value.length;
  const {
    getWeeklyCaloriesAsBurgers,
    getWeeklyUnitsAndCalories,
    getWeeklyUnitsAsSpirits,
    getWeeklyUnitsAsBeers
  } = findScoreGetters(context.root.$store);

  let drinkType: Drinks = Drinks.spirit;
  let weeklyDrinks;
  if (numberDrinkingDays >= 4 || drinkFrequency !== DrinkFrequency.Weekly) {
    drinkType = Drinks.beer;
    weeklyDrinks = getWeeklyUnitsAsBeers();
  } else {
    weeklyDrinks = getWeeklyUnitsAsSpirits();
  }

  const weeklyCaloriesAsBurgers = getWeeklyCaloriesAsBurgers();
  const weeklyUnitsAndCalories = getWeeklyUnitsAndCalories();

  return {
    drinkType,
    weeklyCaloriesAsBurgers,
    weeklyDrinks,
    weeklyUnitsAndCalories
  };
};
